import { isConfigFlagDisabled } from "@/utils/configFlag";

/**
 * `window.rechnerCustomConfig.enable_accessibility_tools` — accessibility tools:
 * header **Ansicht** menu, footer link to `/barrierefreiheit`, and display-preference
 * CSS (dark mode, high contrast, font size).
 * Default: enabled. Only explicit false-like values disable all of the above.
 */
export function isAccessibilityToolsEnabled(): boolean {
  if (typeof window === "undefined") return true;
  const cfg = window.rechnerCustomConfig;
  if (!cfg) return true;

  const raw = cfg.enable_accessibility_tools ?? cfg.enable_accessibility;
  if (raw === undefined) return true;
  return !isConfigFlagDisabled(raw);
}
